import { render, staticRenderFns } from "./Dislikes.vue?vue&type=template&id=707cd9d8&scoped=true&lang=pug&"
import script from "./Dislikes.vue?vue&type=script&lang=js&"
export * from "./Dislikes.vue?vue&type=script&lang=js&"
import style0 from "./Dislikes.vue?vue&type=style&index=0&id=707cd9d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707cd9d8",
  null
  
)

export default component.exports